/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

//const select2 = require.context('vendor/jquery.js');
//const j = require('../vendor/jquery');

require('@rails/ujs').start();
require("turbolinks").start();
require("@rails/activestorage").start();

const routeMatcher = require("../vendor/route-matcher").routeMatcher;

import 'bootstrap'

const select2 = require('../vendor/select2.min');

const leaseApplications = require("../screens/lease_applications");
const newLease = require("../screens/new_lease");
const billForm = require("../screens/bill_form");
const invoiceForm = require("../screens/invoice_form");

$(document).on('ready turbolinks:load', function() {
  $("#bill_related_unit_id").select2();
  $("#bill_related_lease_id").select2();
  $("#invoice_related_unit_id").select2();
  $("#invoice_related_lease_id").select2();
  $("#lease_unit_id").select2();
});

const routes = [
  [ "/lease_applications", leaseApplications ],
  [ "/leases/new", newLease ],
  [ "/bills/new", billForm ],
  [ "/bills/:id/edit", billForm ],
  [ "/invoices/new", invoiceForm ],
  [ "/invoices/:id/edit", invoiceForm ],
];

$(document).on('ready turbolinks:load', function () {
  const url = window.location.pathname;

  for(let i = 0; i < routes.length; i++) {
    let match = routeMatcher(routes[i][0]).parse(url);

    if(match !== null) {
      routes[i][1]();

      break;
    }
  }
});
